import React from 'react';

import './NetWorthTabInfo.css';

export const NetWorthTabInfo = ({ incomeAmt }) => {
  return <div className="net-worth-tabs-amount">${incomeAmt}</div>;
};
